var _defs, _mask, _mask2, _g, _mask3, _g2, _mask4, _g3, _mask5, _g4, _mask6, _g5, _mask7, _g6, _mask8, _g7, _mask9, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPermission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 438,
    height: 268,
    viewBox: "0 0 438 268",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path_0",
    transform: "translate(0 0) rotate(0 201.50000000000006 116.5)",
    d: "M0,233L403,233L403,0L0,0L0,233Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_1",
    transform: "translate(0 0.1110004085578302) rotate(0 19.32485537546699 4.555947449419243)",
    d: "M0,9.11L38.65,9.11L38.65,0L0,0L0,9.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_2",
    transform: "translate(0.02070550582045698 0.02388290977362168) rotate(0 19.34411756380279 4.53727529456244)",
    d: "M0,9.07L38.69,9.07L38.69,0L0,0L0,9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_3",
    transform: "translate(0 0.3624234266496451) rotate(0 6.57970178920497 13.96798832764136)",
    d: "M0,27.94L13.16,27.94L13.16,0L0,0L0,27.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_4",
    transform: "translate(0.0285773916501371 0.3624234266496451) rotate(0 6.579540030384295 13.96798832764136)",
    d: "M0,27.94L13.16,27.94L13.16,0L0,0L0,27.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_5",
    transform: "translate(0.04174628927580531 0.05521120744958813) rotate(0 4.969508387087147 4.969264645761053)",
    d: "M0,9.94L9.94,9.94L9.94,0L0,0L0,9.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_6",
    transform: "translate(0.02459017583535929 0.0848398765493308) rotate(0 5.422668161329565 5.361653285401845)",
    d: "M0,10.72L10.85,10.72L10.85,0L0,0L0,10.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_7",
    transform: "translate(0.000006637488692027203 0) rotate(0 29.73594601209893 29.670710713101236)",
    d: "M0,59.34L59.47,59.34L59.47,0L0,0L0,59.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_8",
    transform: "translate(0.00002471112455907479 0.000004924514340340927) rotate(0 14.82666238023318 9.849026220896995)",
    d: "M0,19.7L29.65,19.7L29.65,0L0,0L0,19.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 219 134)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(12 35)  rotate(0 201.5 116.5)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-0",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_0"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8499\\u7248",
    fillRule: "evenodd",
    style: {
      fill: "#D8D8D8"
    },
    transform: "translate(0 0)  rotate(0 201.50000000000006 116.5)",
    opacity: 0,
    d: "M0,233L403,233L403,0L0,0L0,233Z "
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(26 24)  rotate(0 154 228.5)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(75.26453846153846 418.9593452685422)  rotate(0 81.73846153846155 18.94629156010231)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 81.73846153846155 18.94629156010231)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(111.8782558909455 2.192703486678516)  rotate(0 25.46923076923077 17.762148337595914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    style: {
      fill: "#E5E3EA"
    },
    transform: "translate(0.2126500196344567 3.552713678800501e-15)  rotate(0 25.05474091677604 16.41040500194703)",
    opacity: 1,
    d: "M14.18,29.55C19.58,27.77 21.35,31.08 26.23,32.05C31.11,33.01 40.89,33.87 50.11,29.4C50.06,26.79 48.8,22.91 46.85,22.81C37.91,22.33 33.08,19.62 27.72,15.68C23.25,12.39 19.98,7.73 20.33,0L0.9,0C0.9,0 -0.35,20.98 0.1,28.66C0.1,28.66 8.32,31.49 14.18,29.55Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    style: {
      fill: "#7986A8"
    },
    transform: "translate(0.2643954632124432 27.28934345067828)  rotate(0 24.96336488192363 3.655673440371338)",
    opacity: 1,
    d: "M14,1.24C5.29,1.61 0,0 0,0L0.1,4.47C0.1,4.47 3.68,6.68 12.18,5.35C14.96,3.76 19.48,3.73 22.9,6.33C26.36,7.84 36.04,7.23 39.92,6.97C46.24,6.55 49.14,5.41 49.14,5.41C49.14,5.41 50.31,3.88 49.8,1.5C47.69,3.06 32.24,4.47 25.14,3.43C18.03,2.39 19.91,0.98 14,1.24Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(1.4210854715202e-14 27.22439626465354)  rotate(0 25.272130063511405 2.0518073240103707)",
    opacity: 1,
    d: "M13.44,1.35C16.67,1.21 17.82,1.63 19.41,2.22C20.71,2.7 22.32,3.29 25.51,3.76C27.16,4 29.24,4.1 31.49,4.1C39.12,4.1 48.76,2.89 50.44,1.64C50.55,1.56 50.58,1.39 50.49,1.28C50.4,1.16 50.24,1.14 50.12,1.22C48.06,2.76 32.56,4.26 25.59,3.24C22.45,2.78 20.87,2.2 19.6,1.73C17.94,1.12 16.75,0.69 13.42,0.83C4.86,1.2 0.38,0.02 0.33,0.01C0.19,-0.03 0.05,0.05 0.01,0.19C-0.03,0.33 0.06,0.48 0.19,0.51C0.19,0.51 4.79,1.72 13.44,1.35Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(33.92522326488263 24.71112788931417)  rotate(0 7.043416287948875 0.8408356564435555)",
    opacity: 1,
    d: "M13.87,0.52C14.01,0.49 14.11,0.35 14.08,0.21C14.05,0.07 13.91,-0.02 13.77,0C13.69,0.02 5.26,1.61 0.3,1.03C0.15,1.02 0.02,1.12 0,1.26C-0.02,1.41 0.09,1.54 0.23,1.55C1.01,1.64 1.88,1.68 2.78,1.68C7.71,1.68 13.8,0.53 13.87,0.52Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(0.5544093131976338 14.68525905683189)  rotate(0 5.25531777496572 6.453735512420525)",
    opacity: 1,
    d: "M10.26,12.91C10.41,12.9 10.52,12.77 10.51,12.63C9.76,1.64 0.4,0.02 0.31,0C0.17,-0.02 0.03,0.08 0,0.22C-0.02,0.36 0.08,0.5 0.22,0.52C0.31,0.53 9.26,2.08 9.98,12.66C9.99,12.8 10.11,12.91 10.25,12.91C10.25,12.91 10.26,12.91 10.26,12.91Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(17.9486267500647 5.8366664511733)  rotate(0 7.42923567624611 11.61507254723861)",
    opacity: 1,
    d: "M14.58,23.03C15.19,20.5 15.32,15.72 9.39,12.13C-0.46,6.17 0.56,0.37 0.58,0.31C0.58,0.31 0.51,0.03 0.37,0.01C0.37,0.01 0.09,0.07 0.06,0.21C0.01,0.46 -1.08,6.41 9.12,12.58C14.48,15.82 14.77,19.98 14.06,22.91C14.03,23.05 14.12,23.19 14.32,23.23C14.44,23.23 14.55,23.15 14.58,23.03Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(17.61548014656947 9.920836262049342)  rotate(0 3.2130035491447355 1.88384238354603)",
    opacity: 1,
    d: "M1.54,3.65C3.43,1.88 6.41,1.49 6.41,1.49C6.41,1.49 6.61,0.11 5.62,0.01C3.54,-0.19 0.25,2.27 0.25,2.27C-0.5,3.2 0.57,4.1 1.54,3.65Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 37",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(20.19671155433273 12.48234009807405)  rotate(0 3.060101563063329 2.0458916225777894)",
    opacity: 1,
    d: "M1.41,3.98C3.93,1.97 6.11,1.67 6.11,1.67C6.11,1.67 6.34,-0.12 4.82,0.01C2.44,0.2 0.27,2.48 0.27,2.48C-0.47,3.41 0.44,4.44 1.41,3.98Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 39",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(23.51833631707404 15.07684636694819)  rotate(0 2.9434402124589116 1.807954838385241)",
    opacity: 1,
    d: "M1.4,3.51C3.78,1.34 5.87,1.54 5.87,1.54C5.87,1.54 6.12,0.54 4.68,0.07C3.19,-0.43 0.27,2 0.27,2C-0.47,2.93 0.43,3.96 1.4,3.51Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 41",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(16.13880319529185 6.910979847371135)  rotate(0 3.3682220772264166 1.7018298251835735)",
    opacity: 1,
    d: "M1.3,3.34C4.67,1.62 6.26,1.66 6.26,1.66C6.26,1.66 7.49,0.38 6,0.07C3.62,-0.42 0.37,1.71 0.37,1.71C-0.49,2.54 0.28,3.67 1.3,3.34Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0.999005647516158 0)  rotate(0 25.46923076923077 17.762148337595914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    style: {
      fill: "#E5E3EA"
    },
    transform: "translate(0.6163296852750761 3.552713678800501e-15)  rotate(0 25.054740916776 16.410405001947034)",
    opacity: 1,
    d: "M49.21,0L29.78,0C30.13,7.73 26.86,12.39 22.39,15.68C17.03,19.62 12.2,22.33 3.26,22.81C1.31,22.91 0.05,26.79 0,29.4C9.22,33.87 19,33.01 23.88,32.05C28.76,31.08 30.53,27.77 35.93,29.55C41.79,31.49 50.01,28.66 50.01,28.66C50.46,20.98 49.21,0 49.21,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    style: {
      fill: "#7986A8"
    },
    transform: "translate(0.7473363114019023 27.28934345067829)  rotate(0 24.963364881923596 3.6556734403713413)",
    opacity: 1,
    d: "M24.79,3.43C17.68,4.47 2.24,3.06 0.13,1.5C-0.38,3.88 0.79,5.41 0.79,5.41C0.79,5.41 3.68,6.55 10.01,6.97C13.89,7.23 23.57,7.84 27.03,6.33C30.45,3.73 34.97,3.76 37.75,5.35C46.24,6.68 49.82,4.47 49.82,4.47L49.93,0C49.93,0 44.64,1.61 35.93,1.24C30.02,0.98 31.9,2.39 24.79,3.43Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(0.3942014114386936 27.22439626465355)  rotate(0 25.272130063511415 2.051807324010369)",
    opacity: 1,
    d: "M37.12,0.83C33.79,0.69 32.6,1.12 30.94,1.73C29.67,2.2 28.1,2.78 24.95,3.24C17.99,4.26 2.49,2.76 0.42,1.22C0.31,1.14 0.14,1.16 0.05,1.28C-0.04,1.39 -0.01,1.56 0.11,1.64C1.78,2.89 11.42,4.1 19.06,4.1C21.3,4.1 23.39,4 25.03,3.76C28.23,3.29 29.84,2.7 31.13,2.22C32.73,1.63 33.87,1.21 37.1,1.35C45.75,1.72 50.35,0.51 50.35,0.51C50.49,0.48 50.57,0.33 50.53,0.19C50.5,0.05 50.35,-0.03 50.21,0.01C50.17,0.02 45.68,1.2 37.12,0.83Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(2.9264056976812185 24.71112788931418)  rotate(0 7.04341628794887 0.8408356564435555)",
    opacity: 1,
    d: "M13.85,1.55C14,1.54 14.1,1.41 14.09,1.26C14.07,1.12 13.93,1.02 13.79,1.03C8.83,1.61 0.4,0.02 0.32,0C0.17,-0.02 0.03,0.07 0,0.21C-0.02,0.35 0.07,0.49 0.21,0.52C0.29,0.53 6.38,1.68 11.31,1.68C12.21,1.68 13.07,1.64 13.85,1.55Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(39.87341667533248 14.68525905683189)  rotate(0 5.255317774965715 6.45373551242053)",
    opacity: 1,
    d: "M0.53,12.66C1.25,2.08 10.2,0.53 10.29,0.52C10.43,0.5 10.53,0.36 10.51,0.22C10.48,0.08 10.34,-0.02 10.2,0C10.11,0.02 0.75,1.64 0,12.63C-0.01,12.77 0.1,12.9 0.25,12.91C0.25,12.91 0.26,12.91 0.26,12.91C0.4,12.91 0.52,12.8 0.53,12.66Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(18.13136343590471 5.836666451173302)  rotate(0 7.429235676246075 11.615072547238615)",
    opacity: 1,
    d: "M0.79,22.91C0.09,19.98 0.38,15.82 5.74,12.58C15.94,6.41 14.85,0.46 14.8,0.21C14.77,0.07 14.49,0.01 14.49,0.01C14.35,0.03 14.28,0.31 14.28,0.31C14.29,0.37 15.32,6.17 5.46,12.13C-0.46,15.72 -0.33,20.5 0.28,23.03C0.31,23.15 0.42,23.23 0.54,23.23C0.74,23.19 0.83,23.05 0.79,22.91Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(26.896974293602632 9.920836262049345)  rotate(0 3.213003549144718 1.8838423835460325)",
    opacity: 1,
    d: "M0.81,0.01C-0.18,0.11 0.02,1.49 0.02,1.49C0.02,1.49 3,1.88 4.88,3.65C5.86,4.1 6.92,3.2 6.17,2.27C6.17,2.27 2.89,-0.19 0.81,0.01Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 37",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(24.621546858002173 12.48234009807405)  rotate(0 3.060101563063329 2.045891622577791)",
    opacity: 1,
    d: "M1.3,0.01C-0.22,-0.12 0.01,1.67 0.01,1.67C0.01,1.67 2.19,1.97 4.71,3.98C5.68,4.44 6.59,3.41 5.85,2.48C5.85,2.48 3.68,0.2 1.3,0.01Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 39",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(21.53324479646972 15.0768463669482)  rotate(0 2.94344021245891 1.8079548383852415)",
    opacity: 1,
    d: "M1.21,0.07C-0.23,0.54 0.02,1.54 0.02,1.54C0.02,1.54 2.1,1.34 4.49,3.51C5.46,3.96 6.36,2.93 5.61,2C5.61,2 2.7,-0.43 1.21,0.07Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 41",
    fillRule: "evenodd",
    style: {
      fill: "#C7C4CE"
    },
    transform: "translate(28.063214188716895 6.910979847371138)  rotate(0 3.3682220772264113 1.701829825183574)",
    opacity: 1,
    d: "M0.74,0.07C-0.75,0.38 0.47,1.66 0.47,1.66C0.47,1.66 2.06,1.62 5.44,3.34C6.46,3.67 7.22,2.54 6.37,1.71C6.37,1.71 3.12,-0.42 0.74,0.07Z "
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    style: {
      fill: "#FFB69C"
    },
    transform: "translate(132.5160985362373 39.38397080581145)  rotate(0 23.05479593327158 18.721067019844096)",
    opacity: 1,
    d: "M46.11,23.8C46.11,23.8 42.18,22.45 38.52,21.4C37.66,21.15 37.07,20.39 37.04,19.5L36.37,0L8.63,0L7.97,19.36C7.94,20.27 7.29,21.05 6.41,21.27C2.22,22.32 0,22.68 0,22.68C0,22.68 1.87,37.44 23.47,37.44C45.06,37.44 46.11,23.8 46.11,23.8Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    style: {
      fill: "#FFB69C"
    },
    transform: "translate(105.2097932280287 423.7569039381991)  rotate(0 9.68400823978864 3.02808753123486)",
    opacity: 1,
    d: "M9.49,5.99C14.83,6.34 19.26,5.31 19.37,3.67C19.47,2.04 15.23,0.43 9.88,0.07C4.53,-0.29 0.11,0.75 0,2.38C-0.11,4.02 4.14,5.63 9.49,5.99Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    style: {
      fill: "#E86B6B"
    },
    transform: "translate(106.8939490044147 424.3973934134531)  rotate(0 8.04962819144535 2.244924680195709)",
    opacity: 1,
    d: "M7.9,4.42C12.35,4.72 16.02,3.98 16.1,2.78C16.18,1.58 12.64,0.36 8.19,0.07C3.75,-0.23 0.08,0.5 0,1.71C-0.08,2.91 3.46,4.13 7.9,4.42Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(111.8993212301591 425.5455956308009)  rotate(0 3.045292317758907 1.0153337426930875)",
    opacity: 1,
    d: "M2.94,1.98C4.62,2.16 6.03,1.87 6.09,1.34C6.14,0.8 4.83,0.23 3.15,0.05C1.47,-0.12 0.06,0.16 0,0.7C-0.05,1.23 1.26,1.8 2.94,1.98Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    style: {
      fill: "#FFB594"
    },
    transform: "translate(130.9268673419344 26.85105144459896)  rotate(0 4.33237912193708 6.945968653150765)",
    opacity: 1,
    d: "M8.59,8.53C7.95,3.09 5.22,0.52 5.22,0.52C5.22,0.52 3.62,-0.48 2.07,0.29C0.39,1.13 -0.89,5.11 0.79,8.58C1.73,10.51 4.5,15.05 7.79,13.62C7.79,13.62 8.97,11.79 8.59,8.53Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    style: {
      fill: "#FFB594"
    },
    transform: "translate(170.4388235949144 26.85105144459896)  rotate(0 4.332187415626592 6.945968653150765)",
    opacity: 1,
    d: "M7.88,8.58C9.56,5.11 8.28,1.13 6.59,0.29C5.05,-0.48 3.44,0.52 3.44,0.52C3.44,0.52 0.71,3.09 0.08,8.53C-0.3,11.79 0.88,13.62 0.88,13.62C4.16,15.05 6.94,10.51 7.88,8.58Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    style: {
      fill: "#FFC6A0"
    },
    transform: "translate(135.1054214061214 5.112023032601016)  rotate(0 19.555913420407396 26.20199854358611)",
    opacity: 1,
    d: "M0.48,25.19C1.68,32.17 1.63,32.03 3.22,38.98C3.95,42.14 10.75,52.4 20.24,52.4C29.11,52.4 35.55,42.39 36.27,39.16C37.79,32.35 37.88,32.19 38.8,25.19C40.68,10.89 34.1,0 20.11,0L19.16,0C5.17,0 -1.98,10.98 0.48,25.19Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    style: {
      fill: "#DB836E"
    },
    transform: "translate(144.0039818157909 52.12172114611749)  rotate(0 11.1988280226459 2.91519049356069)",
    opacity: 1,
    d: "M22.28,0.7C22.44,0.54 22.44,0.28 22.28,0.12C22.12,-0.04 21.86,-0.04 21.7,0.12C19.44,2.35 15.8,5.02 11.31,5.02C6.73,5.02 3,2.53 0.68,0.44C0.51,0.29 0.26,0.3 0.11,0.47C-0.04,0.64 -0.03,0.89 0.13,1.04C2.56,3.23 6.47,5.83 11.31,5.83C16.08,5.83 19.91,3.04 22.28,0.7Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(153.9391426682113 4.741564624379884)  rotate(0 0.769769499536622 0.398685329553508)",
    opacity: 1,
    d: "M1.54,0.4C1.54,0.23 1.41,0.1 1.24,0.1L0.3,0.1C0.13,0.1 0,0.23 0,0.4C0,0.56 0.13,0.7 0.3,0.7L1.24,0.7C1.41,0.7 1.54,0.56 1.54,0.4Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(143.9277518869324 30.10433054925586)  rotate(0 2.334036845227061 1.7294969596031076)",
    opacity: 1,
    d: "M4.67,2.92C4.67,1.31 3.62,0 2.33,0C1.05,0 0,1.31 0,2.92C0,3.22 0.24,3.46 0.54,3.46C0.84,3.46 1.09,3.22 1.09,2.92C1.09,1.92 1.66,1.09 2.33,1.09C3.01,1.09 3.58,1.92 3.58,2.92C3.58,3.22 3.82,3.46 4.12,3.46C4.42,3.46 4.67,3.22 4.67,2.92Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(160.6082979820204 30.10433054925586)  rotate(0 2.334036845227061 1.7294969596031076)",
    opacity: 1,
    d: "M4.67,2.92C4.67,1.31 3.62,0 2.33,0C1.05,0 0,1.31 0,2.92C0,3.22 0.24,3.46 0.54,3.46C0.84,3.46 1.09,3.22 1.09,2.92C1.09,1.92 1.66,1.09 2.33,1.09C3.01,1.09 3.58,1.92 3.58,2.92C3.58,3.22 3.82,3.46 4.12,3.46C4.42,3.46 4.67,3.22 4.67,2.92Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    style: {
      fill: "#DB836E"
    },
    transform: "translate(153.318860012419 26.68029958432786)  rotate(0 2.7945410536476203 6.765352034554695)",
    opacity: 1,
    d: "M3.19,12.72L0.41,12.72C0.18,12.72 0,12.9 0,13.12C0,13.35 0.18,13.53 0.41,13.53L3.61,13.53C3.72,13.53 3.82,13.49 3.9,13.41C3.98,13.33 4.02,13.22 4.02,13.11L3.77,3.55L5.53,0.62C5.65,0.42 5.58,0.17 5.39,0.06C5.2,-0.06 4.95,0 4.83,0.2L3.01,3.23C2.97,3.29 2.95,3.45 2.95,3.45L3.19,12.72Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    style: {
      fill: "#DB836E"
    },
    transform: "translate(153.0879291625579 49.04220265131115)  rotate(0 2.0329093985171625 0.407456406803707)",
    opacity: 1,
    d: "M4.07,0.41C4.07,0.18 3.88,0 3.66,0L0.41,0C0.18,0 0,0.18 0,0.41C0,0.63 0.18,0.81 0.41,0.81L3.66,0.81C3.88,0.81 4.07,0.63 4.07,0.41Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    style: {
      fill: "#F7F7F7"
    },
    transform: "translate(149.7213641927711 43.761535724309)  rotate(0 5.379611922150135 1.513010825655545)",
    opacity: 1,
    d: "M0,0.01C0,0.01 1.4,3.03 5.31,3.03C9.22,3.03 10.76,0 10.76,0L0,0.01Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 37",
    fillRule: "evenodd",
    style: {
      fill: "#DB836E"
    },
    transform: "translate(149.3136312143727 43.35376036924168)  rotate(0 5.78731576438261 1.9208659177887915)",
    opacity: 1,
    d: "M5.71586 3.02651C8.30586 3.02651 9.76586 1.63651 10.4059 0.816508L1.13586 0.826508C1.73586 1.64651 3.13586 3.02651 5.71586 3.02651Z M11.53 0.59C11.59 0.47 11.59 0.32 11.51 0.19C11.44 0.07 11.31 0 11.17 0L0.41 0.01C0.27 0.01 0.14 0.09 0.06 0.2C-0.01 0.32 -0.02 0.47 0.04 0.59C0.1 0.73 1.59 3.84 5.72 3.84C9.83 3.84 11.46 0.72 11.53 0.59Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 39",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(132.9341174381357 0.0001702151194052971)  rotate(0 21.35212997658243 16.575377074226296)",
    opacity: 1,
    d: "M42.09,25.58C44.26,12.58 41.26,0.22 23.42,0C23.42,0 16.55,-0.23 7.92,3.73C5.58,4.8 3.78,5.55 2.5,6.04C0.93,6.65 -0.07,8.2 0,9.89C0.67,24.26 3.19,33.15 3.19,33.15L4.11,26.41L5.29,24.39C5.57,23.38 5.41,19.44 6.36,15.52L36.48,15.54C37.36,20.24 37.54,24.44 37.54,24.44L39.33,26.41L40.63,33.15C41.32,30.12 41.64,28.31 42.09,25.58Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 41",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(140.3169796606586 25.6342802820296)  rotate(0 5.71033760496975 1.207333959623071)",
    opacity: 1,
    d: "M2.29,0.74C2.22,0.74 2.16,0.75 2.1,0.77L0.37,1.36C0.08,1.45 -0.07,1.76 0.03,2.05C0.11,2.27 0.32,2.41 0.54,2.41C0.54,2.41 0.66,2.41 0.72,2.39L2.35,1.83C3.43,1.87 9.34,2.03 11.14,1.02C11.4,0.87 11.5,0.54 11.35,0.28C11.2,0.02 10.87,-0.08 10.61,0.07C9.25,0.84 4.15,0.81 2.29,0.74Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 43",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(158.0617624847331 25.85921448613542)  rotate(0 5.47215839217907 1.0948668575701606)",
    opacity: 1,
    d: "M10.23,2.16C10.28,2.18 10.34,2.19 10.4,2.19C10.63,2.19 10.84,2.05 10.91,1.82C11.01,1.54 10.86,1.23 10.58,1.13L8.85,0.54C8.79,0.52 8.72,0.52 8.66,0.51C8.6,0.52 2.94,0.66 0.69,0.02C0.4,-0.06 0.1,0.11 0.02,0.39C-0.06,0.68 0.11,0.98 0.39,1.07C2.66,1.71 7.79,1.62 8.59,1.6L10.23,2.16Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 45",
    fillRule: "evenodd",
    style: {
      fill: "#FFB594"
    },
    transform: "translate(75.67982649890664 66.76831056272151)  rotate(0 22.027572510530543 40.93035281303134)",
    opacity: 1,
    d: "M20.77,18.51C20.77,18.51 5.51,41.37 1.96,50.66C-1.6,59.96 -0.42,81.28 6.47,81.84C14.2,82.48 29.81,59.73 37.15,46.18C51.38,17.73 39.21,0 39.21,0C29.36,2.19 20.77,18.51 20.77,18.51Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 47",
    fillRule: "evenodd",
    style: {
      fill: "#FFC6A0"
    },
    transform: "translate(0.000009156049018945055 78.70571007299391)  rotate(0 44.884552898400514 35.11218543979671)",
    opacity: 1,
    d: "M21.44,6.71C14.57,9.44 6.1,9.44 1.95,7.18C-2.34,4.84 0.51,15.95 9.86,18.47C19.2,20.98 30.78,21.03 30.78,21.03C30.78,21.03 64.63,69.8 79.22,70.22C93.81,70.63 89.02,52.19 89.02,52.19C89.02,52.19 87.75,43.95 74.95,36.78C56.48,26.44 38.66,9.81 38.66,9.81C38.66,9.81 31.27,1.38 26.24,2.09C21.2,2.82 15.9,1.65 12.31,0.21C8.71,-1.22 10.14,5.01 21.44,6.71Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 49",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(2.027885227065438 90.52380933463095)  rotate(0 15.63718771272417 2.1542199988787374)",
    opacity: 1,
    d: "M0.58,1.06C0.56,0.83 0.58,0.67 0.66,0.63C0.89,0.48 1.6,0.79 2,1.04C4.31,2.98 8.37,4.31 12.12,4.31C14.21,4.31 16.22,3.89 17.77,2.94C25.76,-1.96 30.6,2.17 30.8,2.35C30.92,2.45 31.1,2.44 31.2,2.32C31.31,2.21 31.3,2.02 31.18,1.92C31.12,1.87 29.82,0.73 27.47,0.23C25.31,-0.23 21.83,-0.22 17.47,2.45C13.34,4.99 5.83,3.51 2.34,0.57C2.11,0.43 0.98,-0.25 0.36,0.14C0.07,0.32 -0.04,0.65 0.01,1.13C0.03,1.29 0.17,1.4 0.33,1.38C0.49,1.36 0.6,1.22 0.58,1.06Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 51",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(0.0639944095892608 86.52402411274949)  rotate(0 8.14717918029681 1.7877955733205084)",
    opacity: 1,
    d: "M0.57,1.44C0.59,1.13 0.66,0.73 0.9,0.61C1.29,0.44 2.06,0.87 2.49,1.2C5.67,3.09 8.95,3.58 11.5,3.58C14.19,3.58 16.05,3.03 16.09,3.02C16.24,2.97 16.33,2.81 16.28,2.66C16.24,2.51 16.07,2.42 15.92,2.47C15.86,2.49 9.1,4.46 2.82,0.73C2.69,0.63 1.49,-0.29 0.66,0.09C0.25,0.28 0.03,0.73 0,1.42C-0.01,1.57 0.12,1.71 0.28,1.72C0.44,1.72 0.57,1.6 0.57,1.44Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 53",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(1.004768561260427 88.55942788647283)  rotate(0 8.10041842548512 1.9637974316750044)",
    opacity: 1,
    d: "M0.49,0.11C0.16,0.28 0,0.64 0,1.18C0,1.34 0.13,1.47 0.29,1.47C0.45,1.47 0.58,1.34 0.58,1.18C0.58,0.97 0.61,0.69 0.76,0.61C1,0.48 1.52,0.72 1.72,0.85C5.1,3.33 8.85,3.93 11.65,3.93C14.19,3.93 15.95,3.44 15.99,3.43C16.15,3.39 16.23,3.23 16.19,3.08C16.15,2.93 15.99,2.84 15.83,2.88C15.76,2.9 8.27,4.95 2.04,0.37C1.95,0.31 1.09,-0.22 0.49,0.11Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 55",
    fillRule: "evenodd",
    style: {
      fill: "#FFB594"
    },
    transform: "translate(187.9055228446292 66.76831056272151)  rotate(0 22.027572510530543 40.93035281303134)",
    opacity: 1,
    d: "M6.91,46.18C14.25,59.73 29.85,82.48 37.58,81.84C44.48,81.28 45.66,59.96 42.1,50.66C38.54,41.37 23.29,18.51 23.29,18.51C23.29,18.51 14.69,2.19 4.84,0C4.84,0 -7.32,17.73 6.91,46.18Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 57",
    fillRule: "evenodd",
    style: {
      fill: "#FFC6A0"
    },
    transform: "translate(217.8712996428868 78.70571007299391)  rotate(0 44.88456415867172 35.11218543979671)",
    opacity: 1,
    d: "M51.11,9.81C51.11,9.81 33.29,26.44 14.82,36.78C2.02,43.95 0.75,52.19 0.75,52.19C0.75,52.19 -4.04,70.63 10.55,70.22C25.14,69.8 58.99,21.03 58.99,21.03C58.99,21.03 70.57,20.98 79.91,18.47C89.26,15.95 92.11,4.84 87.82,7.18C83.67,9.44 75.21,9.44 68.33,6.71C79.63,5.01 81.06,-1.22 77.46,0.21C73.87,1.65 68.57,2.82 63.53,2.09C58.5,1.38 51.11,9.81 51.11,9.81Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 59",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(274.3383930571513 90.5362404233872)  rotate(0 15.636988386899985 2.148482876896068)",
    opacity: 1,
    d: "M30.94,1.37C30.94,1.37 31.24,1.28 31.26,1.12C31.32,0.64 31.2,0.3 30.92,0.13C30.3,-0.26 29.16,0.42 28.91,0.58C25.44,3.5 17.94,4.98 13.8,2.44C5.44,-2.69 0.15,1.86 0.1,1.91C-0.02,2.01 -0.03,2.19 0.07,2.31C0.18,2.43 0.36,2.44 0.48,2.34C0.53,2.29 5.49,-1.98 13.5,2.93C15.06,3.88 17.06,4.3 19.16,4.3C22.91,4.3 26.96,2.98 29.25,1.05C29.67,0.77 30.39,0.47 30.61,0.61C30.69,0.66 30.72,0.82 30.69,1.05C30.67,1.21 30.78,1.35 30.94,1.37Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 61",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(291.2820385313157 86.52325869523085)  rotate(0 8.14739937630773 1.7867031463604806)",
    opacity: 1,
    d: "M0.21,3.02C0.21,3.02 2.1,3.57 4.78,3.57C7.33,3.57 10.64,3.08 13.83,1.18C14.23,0.87 15,0.44 15.39,0.61C15.64,0.73 15.71,1.13 15.72,1.44C15.73,1.6 15.87,1.73 16.02,1.72C16.18,1.71 16.3,1.58 16.29,1.42C16.27,0.73 16.04,0.28 15.63,0.09C14.8,-0.29 13.61,0.63 13.51,0.71C7.2,4.46 0.44,2.49 0.37,2.47C0.22,2.42 0.06,2.51 0.01,2.66C-0.03,2.82 0.05,2.98 0.21,3.02Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 63",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(290.4355271032467 88.5589980227625)  rotate(0 8.100418425485115 1.964530654458585)",
    opacity: 1,
    d: "M4.55,3.93C7.36,3.93 11.1,3.34 14.47,0.86C14.67,0.73 15.2,0.48 15.44,0.61C15.59,0.69 15.63,0.97 15.63,1.18C15.63,1.34 15.75,1.47 15.91,1.47C16.07,1.47 16.2,1.34 16.2,1.18C16.2,0.64 16.04,0.28 15.71,0.11C15.11,-0.22 14.25,0.31 14.14,0.38C7.94,4.95 0.44,2.9 0.37,2.88C0.21,2.84 0.05,2.93 0.01,3.08C-0.03,3.23 0.06,3.39 0.21,3.43C0.25,3.44 2.02,3.93 4.55,3.93Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 69",
    fillRule: "evenodd",
    style: {
      fill: "#FFB69C"
    },
    transform: "translate(190.3641677228632 423.7569039381991)  rotate(0 9.683609397085545 3.02808753123486)",
    opacity: 1,
    d: "M9.49,0.07C4.14,0.43 -0.11,2.04 0,3.67C0.11,5.31 4.53,6.34 9.88,5.99C15.23,5.63 19.47,4.02 19.37,2.38C19.26,0.75 14.83,-0.29 9.49,0.07Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 71",
    fillRule: "evenodd",
    style: {
      fill: "#E86B6B"
    },
    transform: "translate(191.9480006853925 424.3973934134531)  rotate(0 8.049615026829516 2.244924680195709)",
    opacity: 1,
    d: "M7.9,0.07C3.46,0.36 -0.08,1.58 0,2.78C0.08,3.98 3.75,4.72 8.19,4.42C12.64,4.13 16.18,2.91 16.1,1.71C16.02,0.5 12.35,-0.23 7.9,0.07Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 73",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(196.9519908138529 425.5455956308009)  rotate(0 3.045292809597342 1.0153337426930875)",
    opacity: 1,
    d: "M2.94,0.05C1.26,0.23 -0.05,0.8 0,1.34C0.06,1.87 1.47,2.16 3.15,1.98C4.83,1.8 6.14,1.23 6.09,0.7C6.03,0.16 4.63,-0.12 2.94,0.05Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 79",
    fillRule: "evenodd",
    style: {
      fill: "#6297CC"
    },
    transform: "translate(102.7794640404078 175.7085984408221)  rotate(0 54.2771254476367 127.70700916246015)",
    opacity: 1,
    d: "M15.05,31.98C15.05,31.98 12.05,34.94 13.84,40.84L0,251.63C0,251.63 11.52,257.43 25.42,253.14L49.72,56.42C49.98,54.25 51.82,52.62 54.01,52.62C56.18,52.62 58.02,54.25 58.29,56.4L83.07,253.52C83.07,253.52 97.98,259.12 108.55,251.07L92.88,42.02C93.98,37.67 92.22,33.82 92.22,33.82L88.46,0L18.54,0.2L15.05,31.98Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 81",
    fillRule: "evenodd",
    style: {
      fill: "#E5E3EA"
    },
    transform: "translate(85.99848895050971 66.03553759316428)  rotate(0 19.69521313985649 27.076668955012515)",
    opacity: 1,
    d: "M5.87,25.57C5.12,27 3.53,27.09 2.75,28.46C2.25,29.33 2.54,31.56 2.1,32.31C0.89,34.36 0,35.8 0,35.8C0,35.8 12.85,42.53 22.65,54.15C22.65,54.15 23.37,53.04 24.49,51.25C24.94,50.51 26.06,50.19 26.62,49.26C27.24,48.24 28.24,46.46 28.93,45.28C31.54,40.84 34.21,36.89 35.81,32.89C40.19,21.95 43.32,0.01 27.85,0.01C27.85,0.01 16.24,-0.99 8.19,20.61C7.69,21.96 6.83,23.73 5.87,25.57Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 83",
    fillRule: "evenodd",
    style: {
      fill: "#E5E3EA"
    },
    transform: "translate(112.7776131909175 60.48199497632094)  rotate(0 41.7733566339203 59.97292886223855)",
    opacity: 1,
    d: "M78.91,96.72C78.96,94.58 78.12,92.91 78.17,91.66C79.34,68.47 83.55,5.87 83.55,5.87C82.37,5.51 81.48,5 80.33,4.75C79.28,4.51 74.21,3.83 67.07,2.4C63.74,1.73 63.04,1.54 60.93,0.58C60.93,0.58 60.08,0.47 59.85,0.68C58.38,2.06 52.78,7.4 42.38,7.4C30.41,7.4 25.72,1.73 24.7,0.25C24.56,0.05 24.06,0.04 24.06,0.04C19.23,1.99 14.7,2.35 11.32,3.12C8.45,3.75 7.85,3.81 6.12,4.19C5.15,4.39 3.76,4.19 2.15,4.8C1.08,5.21 0,5.71 0,5.71C0,5.71 2.44,49.78 7.5,98.86C7.5,98.86 3.03,110.11 8.33,116.95C8.33,116.95 40.08,123.74 78.53,116.88C82.68,111.11 78.04,102.39 78.04,102.39C78.04,100.08 78.85,99.08 78.91,96.72Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 85",
    fillRule: "evenodd",
    style: {
      fill: "#E5E3EA"
    },
    transform: "translate(184.2006520671253 66.03499549751626)  rotate(0 18.83905366180342 27.3828512562029)",
    opacity: 1,
    d: "M9.8,0.01C-1.19,0.01 -1.86,20.74 2.52,31.68C4.26,36.04 7.5,42 10.39,46.81C10.82,47.53 11.01,48.91 11.41,49.56C11.89,50.34 12.75,50.47 13.15,51.13C14.54,53.34 15.46,54.77 15.46,54.77C24.62,41.81 37.68,35.19 37.68,35.19C37.68,35.19 36.79,33.84 35.58,31.9C34.98,30.94 35.29,28.99 34.62,27.85C33.87,26.58 32.14,26.12 31.45,24.84C30.62,23.29 29.91,21.81 29.46,20.61C21.42,-0.99 9.8,0.01 9.8,0.01Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 87",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(218.8273288459302 117.3002477298749)  rotate(0 5.742682456158845 5.84579992492786)",
    opacity: 1,
    d: "M1.08,11.25C2.23,5.47 11.18,1.03 11.18,1.03C11.45,0.9 11.56,0.57 11.43,0.3C11.3,0.04 10.98,-0.08 10.7,0.06C10.32,0.24 1.27,4.73 0.01,11.04C-0.05,11.34 0.14,11.62 0.44,11.68C0.44,11.68 0.51,11.69 0.54,11.69C0.8,11.69 1.03,11.51 1.08,11.25Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 89",
    fillRule: "evenodd",
    style: {
      fill: "#EA967D"
    },
    transform: "translate(78.73011302990729 117.3003283559871)  rotate(0 5.44043732406415 7.273372039936975)",
    opacity: 1,
    d: "M10.45,14.54C10.74,14.47 10.93,14.18 10.87,13.89C9.21,6.02 1.2,0.34 0.86,0.1C0.61,-0.07 0.27,-0.01 0.1,0.23C-0.07,0.48 -0.01,0.82 0.23,0.99C0.31,1.04 8.23,6.66 9.8,14.11C9.86,14.37 10.09,14.55 10.34,14.55L10.45,14.54Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 91",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(155.5799881195551 188.4352720566974)  rotate(0 0.39884430027805706 3.0316032459248845)",
    opacity: 1,
    d: "M0.78,5.68L0.78,0.38C0.78,0.17 0.61,0 0.4,0C0.19,0 0.02,0.17 0.02,0.38L0.02,5.68C0.02,5.89 0.19,6.06 0.4,6.06C0.61,6.06 0.78,5.89 0.78,5.68Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 93",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(155.73543721864 188.434793634302)  rotate(0 3.9513606874362637 15.67630715804394)",
    opacity: 1,
    d: "M7.49,26.91C7.9,18.44 7.9,0.56 7.9,0.38C7.9,0.38 7.73,0 7.52,0C7.31,0 7.14,0.38 7.14,0.38C7.14,0.56 7.14,18.42 6.73,26.88C6.59,29.97 0.41,30.59 0.35,30.59C0.14,30.61 -0.02,30.8 0,31.01C0.02,31.21 0.19,31.35 0.38,31.35C0.7,31.32 7.31,30.67 7.49,26.91Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 95",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(160.0866014956191 218.7290546550681)  rotate(0 6.784840353638925 3.4863054740250874)",
    opacity: 1,
    d: "M0.55,6.93L13.36,0.72C13.54,0.63 13.62,0.4 13.53,0.21C13.44,0.03 13.21,-0.05 13.02,0.04L0.21,6.25C0.03,6.34 -0.05,6.57 0.04,6.76C0.1,6.89 0.24,6.97 0.38,6.97C0.38,6.97 0.49,6.96 0.55,6.93Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 97",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(137.2367986095294 198.4280008936924)  rotate(0 9.561664480684826 14.75853352941178)",
    opacity: 1,
    d: "M19.12,29.14L19.12,0.38C19.12,0.38 18.95,0 18.74,0C18.53,0 18.36,0.38 18.36,0.38L18.36,28.5L0.56,19.01C0.38,18.91 0.15,18.98 0.05,19.17C-0.05,19.35 0.02,19.58 0.2,19.68L18.56,29.47L18.74,29.52L18.94,29.46C19.05,29.39 19.12,29.14 19.12,29.14Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 99",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(134.2774273076159 228.6030451880554)  rotate(0 1.9263058601319756 0.5201712656463116)",
    opacity: 1,
    d: "M0.42,1.04L3.51,0.76C3.72,0.74 3.87,0.56 3.85,0.35C3.83,0.14 3.65,-0.02 3.44,0L0.35,0.28C0.14,0.3 -0.02,0.48 0,0.69C0.02,0.89 0.19,1.04 0.38,1.04C0.38,1.04 0.4,1.04 0.42,1.04Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 101",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(141.590556628654 227.251134041198)  rotate(0 5.752478242837925 0.8657761750069995)",
    opacity: 1,
    d: "M0.42,1.73L11.16,0.76C11.37,0.74 11.52,0.56 11.5,0.35C11.49,0.14 11.3,-0.02 11.09,0L0.35,0.97C0.14,0.99 -0.02,1.18 0,1.39C0.02,1.58 0.19,1.73 0.38,1.73L0.42,1.73Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 103",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(124.9436553146322 279.8442125228622)  rotate(0 9.58997544189158 72.477822006464)",
    opacity: 1,
    d: "M0.76,144.62L7.41,90.95L19.18,0.43C19.18,0.43 19.06,0.03 18.85,0C18.64,-0.03 18.42,0.33 18.42,0.33L6.66,90.84L0,144.54C0,144.54 0.13,144.93 0.38,144.96C0.57,144.96 0.76,144.62 0.76,144.62Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 105",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(143.9789417350416 269.7904045278087)  rotate(0 0.7253669331862935 3.031462630851138)",
    opacity: 1,
    d: "M0.76,5.73L1.45,0.43C1.47,0.22 1.33,0.03 1.12,0C0.92,-0.02 0.72,0.12 0.69,0.33L0,5.63C-0.02,5.84 0.12,6.03 0.33,6.06C0.35,6.06 0.37,6.06 0.38,6.06C0.57,6.06 0.73,5.92 0.76,5.73Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 107",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(145.1872006583039 238.8129536724014)  rotate(0 2.134085001768298 13.87028119143922)",
    opacity: 1,
    d: "M0.76,27.41L4.27,0.43C4.29,0.22 4.15,0.03 3.94,0C3.73,-0.02 3.54,0.12 3.51,0.33L0,27.31C-0.02,27.52 0.12,27.71 0.33,27.74L0.38,27.74C0.57,27.74 0.73,27.6 0.76,27.41Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 109",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(149.3061305179504 227.6668653295535)  rotate(0 9.80931047195051 19.111379957476956)",
    opacity: 1,
    d: "M15.42,6.73C14.9,2.89 11.58,0 7.71,0C3.82,0 0.5,2.91 0,6.77C0,6.77 0.12,7.17 0.33,7.2C0.54,7.22 0.73,7.08 0.76,6.87C1.21,3.39 4.2,0.76 7.71,0.76C11.2,0.76 14.19,3.37 14.66,6.83L18.86,37.89C18.89,38.09 19.05,38.22 19.24,38.22C19.5,38.19 19.61,37.79 19.61,37.79L15.42,6.73Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 111",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(168.6308198914139 268.5877612089525)  rotate(0 0.7923357474986406 3.425228707713643)",
    opacity: 1,
    d: "M1.25,6.85C1.46,6.82 1.61,6.63 1.58,6.42L0.76,0.33C0.73,0.12 0.53,-0.02 0.33,0C0.12,0.03 -0.02,0.22 0,0.43L0.83,6.52C0.85,6.71 1.02,6.85 1.2,6.85C1.22,6.85 1.24,6.85 1.25,6.85Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 113",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(169.9292115907172 278.1901916100202)  rotate(0 9.333426867899915 72.54015400080145)",
    opacity: 1,
    d: "M18.66,144.66L0.76,0.33C0.76,0.33 0.54,-0.03 0.33,0C0.13,0.03 0,0.42 0,0.42L17.91,144.75C17.91,144.75 18.1,145.08 18.28,145.08C18.54,145.05 18.66,144.66 18.66,144.66Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 115",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(185.5382197864221 186.649809786064)  rotate(0 4.452271100327593 10.399502424118966)",
    opacity: 1,
    d: "M8.89,20.53C8.95,20.33 8.84,20.12 8.64,20.05C1.98,18.01 0.77,0.53 0.76,0.36C0.75,0.15 0.57,-0.01 0.36,0C0.15,0.01 -0.01,0.2 0,0.41C0.05,1.15 1.26,18.59 8.41,20.78C8.45,20.79 8.49,20.8 8.52,20.8C8.69,20.8 8.84,20.69 8.89,20.53Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 117",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(117.446042917829 187.7213063685331)  rotate(0 4.205684287921592 10.16966538625087)",
    opacity: 1,
    d: "M0.54,20.31C7.86,17.03 8.39,1.07 8.41,0.39C8.42,0.18 8.25,0.01 8.04,0L8.03,0C7.83,0 7.66,0.16 7.65,0.37C7.65,0.53 7.12,16.53 0.23,19.61C0.03,19.7 -0.05,19.92 0.03,20.11C0.1,20.26 0.23,20.34 0.38,20.34L0.54,20.31Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 119",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(202.7620831163154 422.3565115618031)  rotate(0 3.8320150282136183 1.5870675915293475)",
    opacity: 1,
    d: "M0.46,3.17C2.99,2.66 5.35,1.83 7.46,0.72C7.65,0.62 7.72,0.39 7.62,0.2C7.52,0.02 7.29,-0.05 7.11,0.04C5.06,1.12 2.77,1.92 0.31,2.42C0.1,2.46 -0.03,2.66 0.01,2.87C0.04,3.05 0.2,3.17 0.38,3.17L0.46,3.17Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 121",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(185.5899896212227 423.9883516976843)  rotate(0 7.393793786132065 1.199415304595277)",
    opacity: 1,
    d: "M14.45,2.19C14.66,2.16 14.81,1.97 14.78,1.76C14.76,1.56 14.57,1.41 14.36,1.43C6.6,2.33 0.58,0.05 0.52,0.02C0.32,-0.05 0.1,0.05 0.03,0.24C-0.05,0.44 0.05,0.66 0.24,0.74C0.24,0.74 4.63,2.4 10.71,2.4C11.9,2.4 13.15,2.34 14.45,2.19Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 123",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(118.5077267760279 424.3446280646304)  rotate(0 5.05234921426915 0.891026623957032)",
    opacity: 1,
    d: "M9.81,0.75C10.02,0.7 10.14,0.49 10.09,0.29C10.04,0.09 9.84,-0.04 9.63,0.01C6.94,0.68 1.86,0.95 0.36,1.02C0.15,1.03 -0.01,1.21 0,1.42C0.01,1.62 0.18,1.78 0.38,1.78C1.91,1.71 7.05,1.43 9.81,0.75Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 125",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(109.6432528530504 424.4947452302857)  rotate(0 3.671598001218797 0.816964754453153)",
    opacity: 1,
    d: "M7.34,1.28C7.35,1.07 7.19,0.89 6.98,0.87C4.82,0.75 2.62,0.46 0.46,0.01C0.25,-0.03 0.05,0.1 0.01,0.3C-0.03,0.51 0.1,0.71 0.3,0.75C2.5,1.21 4.74,1.51 6.96,1.63C7.16,1.63 7.33,1.48 7.34,1.28Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 127",
    fillRule: "evenodd",
    style: {
      fill: "#4670B2"
    },
    transform: "translate(103.3684044360884 422.6622236698661)  rotate(0 2.3801336684317107 1.029107374138505)",
    opacity: 1,
    d: "M4.75,1.77C4.8,1.57 4.68,1.36 4.48,1.31C2.03,0.66 0.54,0.04 0.53,0.03C0.34,-0.05 0.11,0.04 0.03,0.23C-0.05,0.42 0.04,0.65 0.23,0.73C0.29,0.76 1.77,1.38 4.28,2.05C4.32,2.05 4.35,2.06 4.38,2.06C4.55,2.06 4.7,1.95 4.75,1.77Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 129",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(140.8076477610132 65.80164257287484)  rotate(0 16.410230701667206 3.417618151904186)",
    opacity: 1,
    d: "M32.72,0.54C32.84,0.43 32.86,0.23 32.74,0.1C32.63,-0.02 32.44,-0.03 32.31,0.08C29.71,2.37 23.94,6.22 14.51,6.22C9.03,6.22 4.3,5.21 0.45,3.21C0.3,3.14 0.11,3.19 0.03,3.34C-0.04,3.5 0.02,3.68 0.17,3.76C4.1,5.8 8.93,6.84 14.51,6.84C24.14,6.84 30.05,2.89 32.72,0.54Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 131",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(135.7888331631095 65.33001237110354)  rotate(0 2.15547030847533 1.759598200344769)",
    opacity: 1,
    d: "M4.27,3.37C4.35,3.23 4.31,3.04 4.16,2.95C2.82,2.13 1.59,1.16 0.53,0.09C0.41,-0.03 0.21,-0.03 0.09,0.09C-0.03,0.21 -0.03,0.4 0.09,0.52C1.19,1.63 2.46,2.63 3.84,3.47C3.89,3.5 3.95,3.52 4,3.52C4.11,3.52 4.21,3.47 4.27,3.37Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 133",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(191.987650149066 90.20784341062716)  rotate(0 1.5318920121165436 17.64261072700392)",
    opacity: 1,
    d: "M0.61,35L3.06,0.33C3.08,0.16 2.95,0.01 2.78,0C2.6,-0.01 2.46,0.12 2.45,0.29L0,34.96C-0.01,35.13 0.12,35.27 0.29,35.29C0.29,35.29 0.31,35.29 0.31,35.29C0.47,35.29 0.6,35.16 0.61,35Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 135",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(113.8541781271968 93.87788772117625)  rotate(0 1.5318138835348805 13.156370998731505)",
    opacity: 1,
    d: "M2.78,26.31C2.95,26.29 3.06,25.98 3.06,25.98L0.61,0.28C0.6,0.11 0.44,-0.02 0.28,0C0.11,0.02 0,0.34 0,0.34L2.45,26.03C2.46,26.19 2.6,26.31 2.76,26.31L2.78,26.31Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 137",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(211.6739053808593 98.46739711001189)  rotate(0 3.7262074039901023 2.165691238757361)",
    opacity: 1,
    d: "M0.48,4.28C2.71,2.76 4.99,1.52 7.26,0.59C7.42,0.53 7.49,0.35 7.43,0.19C7.37,0.03 7.18,-0.04 7.03,0.02C4.72,0.97 2.4,2.23 0.13,3.77C-0.01,3.86 -0.04,4.06 0.05,4.2C0.11,4.28 0.21,4.33 0.31,4.33C0.37,4.33 0.43,4.31 0.48,4.28Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 139",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(197.7003604632559 103.4336943370715)  rotate(0 6.418976994233345 6.695935863002165)",
    opacity: 1,
    d: "M0.56,13.25C0.61,13.18 5.22,6.17 12.71,0.55C12.85,0.45 12.88,0.26 12.78,0.12C12.67,-0.01 12.48,-0.04 12.34,0.06C4.76,5.75 0.1,12.85 0.05,12.92C-0.04,13.06 0,13.25 0.14,13.34L0.31,13.39C0.41,13.39 0.51,13.34 0.56,13.25Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 141",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(88.54762001010977 98.67146693462597)  rotate(0 10.865819192094305 9.026017842042094)",
    opacity: 1,
    d: "M21.67,17.56C14.37,8.13 0.6,0.12 0.46,0.04C0.32,-0.04 0.13,0.01 0.04,0.15C-0.04,0.3 0.01,0.49 0.15,0.57C0.29,0.65 13.96,8.61 21.18,17.93C21.24,18.01 21.33,18.05 21.42,18.05C21.75,17.88 21.77,17.69 21.67,17.56Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 143",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(195.2516077837725 75.11569920375335)  rotate(0 0.937852178194362 11.32065285311978)",
    opacity: 1,
    d: "M0.61,22.41C3.45,10.63 0.63,0.33 0.6,0.22C0.56,0.06 0.39,-0.04 0.22,0.01C0.06,0.06 -0.03,0.23 0.01,0.39C0.04,0.49 2.81,10.65 0.01,22.26C-0.03,22.43 0.07,22.59 0.24,22.63C0.26,22.64 0.28,22.64 0.31,22.64C0.45,22.64 0.57,22.55 0.61,22.41Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 145",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(110.5898626550601 78.99047209375013)  rotate(0 1.6336916205093954 10.708855260353856)",
    opacity: 1,
    d: "M3.05,21.4C3.21,21.35 3.3,21.18 3.25,21.02C1.12,14.34 0.62,0.44 0.62,0.3C0.62,0.3 0.48,-0.01 0.3,0C0.13,0.01 0,0.32 0,0.32C0,0.46 0.5,14.45 2.67,21.2C2.71,21.33 2.83,21.42 2.96,21.42C2.99,21.42 3.02,21.41 3.05,21.4Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 147",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(139.9391737941723 131.005913485487)  rotate(0 12.571377642956476 2.637110433372726)",
    opacity: 1,
    d: "M24.87,5.08C25.04,5.06 25.16,4.91 25.14,4.74C25.12,4.57 24.96,4.45 24.8,4.47C14.63,5.76 0.57,0.08 0.42,0.02C0.27,-0.04 0.09,0.03 0.02,0.19C-0.04,0.35 0.04,0.53 0.19,0.59C0.32,0.64 11.78,5.27 21.6,5.27C22.72,5.27 23.82,5.21 24.87,5.08Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 149",
    fillRule: "evenodd",
    style: {
      fill: "#C2C0CC"
    },
    transform: "translate(140.9817911683942 141.6009869995388)  rotate(0 16.42553253056987 1.151045295411322)",
    opacity: 1,
    d: "M32.62,0.6C32.79,0.56 32.88,0.39 32.84,0.23C32.79,0.06 32.62,-0.03 32.46,0.01C20.82,3.22 0.55,0.84 0.34,0.82C0.16,0.8 0.02,0.92 0,1.09C-0.02,1.26 0.1,1.41 0.27,1.43C0.39,1.44 7.71,2.3 16.09,2.3C21.75,2.3 27.89,1.91 32.62,0.6Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 151",
    fillRule: "evenodd",
    style: {
      fill: "#192064"
    },
    transform: "translate(265.4467576639572 88.28486747493179)  rotate(0 6.07517165009324 7.504711822258285)",
    opacity: 1,
    d: "M12.01,12.8C12.31,12.32 12.12,11.68 11.6,11.45C5.45,8.69 3.4,2.5 2.87,0.36C2.78,0.02 2.37,-0.11 2.11,0.11C1.64,0.51 0.94,1.12 0.19,1.83C0.07,1.94 -0.02,2.1 0,2.25C1.22,10.02 7.54,14.02 9.24,14.87C9.79,15.15 10.47,15 10.85,14.5C11.32,13.87 11.72,13.27 12.01,12.8Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 153",
    fillRule: "evenodd",
    style: {
      fill: "#C1C4D6"
    },
    transform: "translate(271.5712493755329 98.49106433876682)  rotate(0 0.49735884244671524 0.4971606059532405)",
    opacity: 1,
    d: "M0.5,0C0.22,0 0,0.22 0,0.5C0,0.77 0.22,0.99 0.5,0.99C0.77,0.99 0.99,0.77 0.99,0.5C0.99,0.22 0.77,0 0.5,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 155",
    fillRule: "evenodd",
    style: {
      fill: "#C1C4D6"
    },
    transform: "translate(273.5600465944393 99.82945099007797)  rotate(0 0.49735884244671524 0.49755929128279774)",
    opacity: 1,
    d: "M0.5,0C0.22,0 0,0.22 0,0.5C0,0.77 0.22,1 0.5,1C0.77,1 0.99,0.77 0.99,0.5C0.99,0.22 0.77,0 0.5,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 157",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(120.2752478852642 177.3621857136783)  rotate(0 35.88242631881373 5.733405127569115)",
    opacity: 1,
    d: "M71.76,8.6C71.46,3.7 71.1,0 71.1,0C71.1,0 41.08,4.96 0.84,0.11C0.36,4.69 0,8.6 0,8.6C0,8.6 35.63,15.05 71.76,8.6Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 159",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(146.543691883596 178.2107198059613)  rotate(0 9.15427437998146 6.43373642606079)",
    opacity: 1,
    d: "M0,11.14C0,11.99 0.67,12.69 1.52,12.72C6.27,12.9 11.38,12.93 16.77,12.74C17.63,12.71 18.31,12 18.31,11.15L18.31,1.6C18.31,0.71 17.58,0 16.69,0.02C12.05,0.15 7.01,0.15 1.64,0C0.75,-0.02 0,0.69 0,1.58L0,11.14Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 161",
    fillRule: "evenodd",
    style: {
      fill: "#5C2552"
    },
    transform: "translate(148.7162765560705 180.3510494643721)  rotate(0 6.9255324300278 4.294560986885983)",
    opacity: 1,
    d: "M0,7.24C0,7.91 0.53,8.47 1.21,8.49C4.77,8.61 8.59,8.63 12.63,8.5C13.31,8.49 13.85,7.92 13.85,7.25L13.85,1.27C13.85,0.56 13.28,0 12.58,0.02C9.09,0.1 5.32,0.1 1.3,0C0.59,-0.02 0,0.55 0,1.25L0,7.24Z "
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(315 184)  rotate(0 19 41.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    style: {
      fill: "#5BA02E"
    },
    transform: "translate(15.95051344645864 4.618527782440651e-13)  rotate(0 6.066770751476075 24.01986696294488)",
    opacity: 1,
    d: "M12.13,6.05C12.13,2.71 9.43,0 6.04,0C2.7,0 0,2.71 0,6.05L0,48.04L12.13,48.04L12.13,6.05Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    style: {
      fill: "#92C110"
    },
    transform: "translate(22.21084194710786 30.27706089188402)  rotate(0 6.11603087612955 13.985257320619464)",
    opacity: 1,
    d: "M12.23,5.92C12.23,2.65 9.58,0 6.3,0L5.93,0C2.66,0 0,2.65 0,5.92L0,27.97L12.23,27.97L12.23,5.92Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    style: {
      fill: "#92C110"
    },
    transform: "translate(4.011920803502584 18.0771555696412)  rotate(0 6.11603087612955 14.87793331980794)",
    opacity: 1,
    d: "M12.23,5.92C12.23,2.65 9.59,0 6.32,0L5.91,0C2.65,0 0,2.65 0,5.92L0,29.76L12.23,29.76L12.23,5.92Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    style: {
      fill: "#CAD5EE"
    },
    transform: "translate(0 47)  rotate(0 19 18)",
    opacity: 1,
    d: "M35.62,36C36.94,36 38,34.98 38,33.74L38,2.26C38,1.02 36.94,0 35.62,0L2.38,0C1.06,0 0,1.02 0,2.26L0,33.74C0,34.98 1.06,36 2.38,36L35.62,36Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    style: {
      fill: "#92C110"
    },
    transform: "translate(17.73569740359849 7.960160912171537)  rotate(0 1.19337187826918 1.190234665584635)",
    opacity: 1,
    d: "M1.19,0C0.53,0 0,0.53 0,1.19C0,1.85 0.53,2.38 1.19,2.38C1.85,2.38 2.39,1.85 2.39,1.19C2.39,0.53 1.85,0 1.19,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    style: {
      fill: "#92C110"
    },
    transform: "translate(24.00089976451149 20.16006623441409)  rotate(0 1.1933718782691816 1.190234665584635)",
    opacity: 1,
    d: "M1.19,0C0.53,0 0,0.53 0,1.19C0,1.85 0.53,2.38 1.19,2.38C1.85,2.38 2.39,1.85 2.39,1.19C2.39,0.53 1.85,0 1.19,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    style: {
      fill: "#5BA02E"
    },
    transform: "translate(5.503635651339347 26.11123956233643)  rotate(0 1.19337187826918 1.1902346655846365)",
    opacity: 1,
    d: "M1.19,0C0.53,0 0,0.53 0,1.19C0,1.85 0.53,2.38 1.19,2.38C1.85,2.38 2.39,1.85 2.39,1.19C2.39,0.53 1.85,0 1.19,0Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    style: {
      fill: "#5BA02E"
    },
    transform: "translate(11.47049504268503 38.31114488457899)  rotate(0 1.19337187826918 1.190234665584633)",
    opacity: 1,
    d: "M1.19,0C0.53,0 0,0.53 0,1.19C0,1.85 0.53,2.38 1.19,2.38C1.85,2.38 2.39,1.85 2.39,1.19C2.39,0.53 1.85,0 1.19,0Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57,
    transform: "translate(360 158)  rotate(0 25.5 14)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 19.5 5)"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-1)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(-0.0001146123354749181 0.1110004085578302)  rotate(0 19.32491268163474 4.555947449419243)",
    opacity: 1,
    d: "M34.1,9.1C36.62,9.1 38.65,7.06 38.65,4.55C38.65,2.03 36.61,0 34.1,0L4.55,0.01C2.03,0.01 0,2.05 0,4.56C0,7.08 2.04,9.11 4.55,9.11L34.1,9.1Z "
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(11.20427343561733 17.98873289814899)  rotate(0 19.5 5)"
  }, _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(0.02070550582045698 0.02388290977362168)  rotate(0 19.34411756380279 4.537275533642931)",
    opacity: 1,
    d: "M34.14,9.06C36.65,9.06 38.69,7.03 38.69,4.53C38.69,2.03 36.65,0 34.13,0L4.55,0.01C2.04,0.01 0,2.04 0,4.55C0,7.05 2.04,9.08 4.55,9.07L34.14,9.06Z "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(18.30942244356978 9.266923008137358)  rotate(0 7.788336412563265 4.497183224537246)",
    opacity: 1,
    d: "M4.49,4.5C4.49,6.97 2.49,8.97 0,8.99L15.57,8.99C13.08,8.99 11.05,6.98 11.05,4.5C11.05,2.02 13.07,0 15.57,0L0,0.01C2.48,0.03 4.49,2.03 4.49,4.5Z "
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#E5E3EA"
    },
    transform: "translate(0 267)  rotate(0 219 0.5)",
    opacity: 1,
    d: "M0,1L438,1L438,0L0,0L0,1Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(38 50)  rotate(0 27 18.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    style: {
      fill: "#CED0DB"
    },
    transform: "translate(17.25947127437841 0.3187796012431148)  rotate(0 8.94935547560362 17.851657669614436)",
    opacity: 1,
    d: "M0,35.7L6.74,35.7L17.9,0L11.15,0L0,35.7Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 4.144134816160495)  rotate(0 27 14.5)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 7 14.5)"
  }, _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 2",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(-0.000215678427591878 0.3624234266496451)  rotate(0 6.579809628418735 13.96798832764136)",
    opacity: 1,
    d: "M5.23,5.31L12.51,5.31C12.87,5.31 13.16,5.02 13.16,4.66L13.16,0.66C13.16,0.29 12.87,0 12.51,0L5.23,0L0.65,0C0.29,0 0,0.29 0,0.66L0,5.31L0,22.62L0,27.28C0,27.64 0.29,27.94 0.65,27.94L5.23,27.94L12.51,27.94C12.87,27.94 13.16,27.64 13.16,27.28L13.16,23.28C13.16,22.92 12.87,22.62 12.51,22.62L5.23,22.62L5.23,5.31Z "
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(39.68483066882071 0)  rotate(0 7 14.5)"
  }, _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(0.0285773916501371 0.3624234266496451)  rotate(0 6.57980962841872 13.96798832764136)",
    opacity: 1,
    d: "M13.16,23.28L13.16,4.66L13.16,0.66C13.16,0.29 12.87,0 12.51,0L7.92,0L0.65,0C0.29,0 0,0.29 0,0.66L0,4.66C0,5.02 0.29,5.31 0.65,5.31L7.92,5.31L7.92,22.62L0.65,22.62C0.29,22.62 0,22.92 0,23.28L0,27.28C0,27.64 0.29,27.94 0.65,27.94L7.92,27.94L12.51,27.94C12.87,27.94 13.16,27.64 13.16,27.28L13.16,23.28Z "
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(12 220)  rotate(0 52 15)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(32.79299542131898 19.98748099794331)  rotate(0 5 5)"
  }, _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-5)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(0.04174628927580531 0.05521120744958813)  rotate(0 4.969508387087147 4.969351742686692)",
    opacity: 1,
    d: "M5.48,0.03C2.75,-0.25 0.31,1.73 0.03,4.46C-0.25,7.19 1.73,9.63 4.46,9.91C7.19,10.19 9.63,8.21 9.91,5.48C10.19,2.75 8.21,0.31 5.48,0.03Z "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(64.67507430315688 1.817043727085756)  rotate(0 5.010040967145955 4.996870249485828)",
    opacity: 1,
    d: "M5.52,0.03C2.77,-0.26 0.31,1.74 0.03,4.49C-0.26,7.23 1.75,9.69 4.5,9.97C7.25,10.25 9.71,8.25 9.99,5.51C10.28,2.76 8.27,0.31 5.52,0.03Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(0 0)  rotate(0 5.010040967145955 4.996870249485828)",
    opacity: 1,
    d: "M5.52,0.03C2.77,-0.25 0.31,1.74 0.03,4.49C-0.26,7.23 1.75,9.68 4.5,9.97C7.25,10.25 9.71,8.25 9.99,5.51C10.28,2.76 8.27,0.31 5.52,0.03Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(92.00257048758935 12.71930608960029)  rotate(0 5.5 5.5)"
  }, _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(0.02459017583535929 0.0848398765493308)  rotate(0 5.42293655820523 5.361653285401845)",
    opacity: 1,
    d: "M5.98,0.03C3,-0.27 0.34,1.87 0.03,4.81C-0.28,7.76 1.89,10.39 4.87,10.7C7.85,11 10.51,8.85 10.82,5.91C11.12,2.96 8.96,0.33 5.98,0.03Z "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    style: {
      fill: "#E4E6EF"
    },
    transform: "translate(5.465499236886497 4.542609317714389)  rotate(0 46.456743513535216 10.4480014307431)",
    opacity: 1,
    d: "M65.03,2.44L92.74,13.43L92.91,12.98L64.99,1.9L32.42,20.33L0.26,0L0,0.41L32.41,20.9L65.03,2.44Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(279 0)  rotate(0 66.5 55.5)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 33)  rotate(0 51 39)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 51 39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#E2E7F2"
    },
    transform: "translate(0 3.437914691943126)  rotate(0 50.95734597156395 37.27364928909952)",
    opacity: 1,
    d: "M2.98,74.55L98.94,74.55C100.58,74.55 101.91,73.21 101.91,71.57L101.91,2.98C101.91,1.34 100.58,0 98.94,0L2.98,0C2.19,0 1.43,0.31 0.87,0.87C0.31,1.43 0,2.19 0,2.98L0,71.57C0,72.36 0.31,73.12 0.87,73.68C1.43,74.24 2.19,74.55 2.98,74.55Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(29.39846882974843 17.32549763033175)  rotate(0 32.5 27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 30",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(0.01659846882969229 0.01223999999996323)  rotate(0 32.02684943492526 26.61611374407582)",
    opacity: 1,
    d: "M63.21,53.23C63.21,53.23 64.05,52.86 64.05,52.41L64.05,1.02C64.05,0.75 63.94,0.49 63.75,0.3C63.56,0.11 63.3,0 63.03,0L1.02,0C0.75,0 0.49,0.11 0.3,0.3C0.11,0.49 0,0.75 0,1.02L0,52.21C0,52.48 0.11,52.74 0.3,52.93C0.49,53.12 0.75,53.23 1.02,53.23L63.21,53.23Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 32",
    fillRule: "evenodd",
    style: {
      fill: "#CED7EC"
    },
    transform: "translate(5.494866642362359 5.42179109004739)  rotate(0 26.69543711265038 17.450445497630326)",
    opacity: 1,
    d: "M52.55,34.9C53.02,34.9 53.39,34.53 53.39,34.08L53.39,0.82C53.39,0.37 53.02,0 52.55,0L0.84,0C0.37,0 0,0.37 0,0.82L0,34.08C0,34.53 0.37,34.9 0.84,34.9L52.55,34.9Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 34",
    fillRule: "evenodd",
    style: {
      fill: "#B2BED9"
    },
    transform: "translate(8.617540503098809 9.231979905213242)  rotate(0 2.346680277068898 0.5007412322274895)",
    opacity: 1,
    d: "M4.69,0.5C4.69,0.22 4.46,0 4.18,0L0.51,0C0.23,0 0,0.22 0,0.5C0,0.78 0.23,1 0.51,1L4.18,1C4.46,1 4.69,0.78 4.69,0.5Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 36",
    fillRule: "evenodd",
    style: {
      fill: "#B2BED9"
    },
    transform: "translate(8.676883412322233 11.63506691943127)  rotate(0 2.3466802770689035 0.5007412322274895)",
    opacity: 1,
    d: "M4.69,0.5C4.69,0.22 4.46,0 4.18,0L0.51,0C0.23,0 0,0.22 0,0.5C0,0.78 0.23,1 0.51,1L4.18,1C4.46,1 4.69,0.78 4.69,0.5Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 38",
    fillRule: "evenodd",
    style: {
      fill: "#393D65"
    },
    transform: "translate(5.494971636893881 12.75150710900487)  rotate(0 26.63181042654029 13.80759201960005)",
    opacity: 1,
    d: "M0.84,27.57L52.42,27.62C52.89,27.62 53.26,27.25 53.26,26.8L53.26,15.97C44.87,15.97 46.39,0 39.65,0C33.26,0 33.71,17.63 27.04,17.63C20.47,17.63 20.91,11.49 12.5,11.49C4.08,11.49 5.56,18.35 0,18.35L0,26.75C0,27.2 0.38,27.57 0.84,27.57Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 40",
    style: {
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeOpacity: 1,
      strokeDasharray: "0 0"
    },
    transform: "translate(5.30543550856745 14.9853696682464)  rotate(0 26.726567991250374 9.386396734642535)",
    d: "M0,18.77C8.4,18.77 7.21,0 12.61,0C17.77,0 16.22,18.77 26.9,18.77C33.46,18.77 35.52,11.12 40.16,11.12C44.8,11.12 47.89,18.77 53.45,18.77 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 42",
    style: {
      stroke: "#E4E6EF",
      strokeWidth: 0.7643601895734594,
      strokeOpacity: 1,
      strokeDasharray: "0 0"
    },
    transform: "translate(6.056650382792533 45.12787450236962)  rotate(0 25.896533722201966 0.05118483412322375)",
    d: "M0,0.05L51.79,0.05 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 44",
    style: {
      stroke: "#E4E6EF",
      strokeWidth: 0.7643601895734594,
      strokeOpacity: 1,
      strokeDasharray: "0 0"
    },
    transform: "translate(6.05665038279261 48.58666919431283)  rotate(0 21.75780678089682 0.05118483412322375)",
    d: "M0,0.05L43.52,0.05 "
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    fillRule: "evenodd",
    style: {
      fill: "#393D65"
    },
    transform: "translate(0 0)  rotate(0 50.93175355450235 5.29660663507109)",
    opacity: 1,
    d: "M0,2.66L0,10.59L101.86,10.59L101.86,2.66C101.86,1.19 100.64,0 99.13,0L2.73,0C1.22,0 0,1.19 0,2.66Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(3.886635071090045 3.396881516587677)  rotate(0 1.948436018957345 1.8997251184834114)",
    opacity: 1,
    d: "M3.9,1.9C3.9,0.85 3.02,0 1.95,0C0.87,0 0,0.85 0,1.9C0,2.95 0.87,3.8 1.95,3.8C3.02,3.8 3.9,2.95 3.9,1.9Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(11.16398104265402 3.396881516587677)  rotate(0 1.948436018957345 1.8997251184834114)",
    opacity: 1,
    d: "M3.9,1.9C3.9,0.85 3.02,0 1.95,0C0.87,0 0,0.85 0,1.9C0,2.95 0.87,3.8 1.95,3.8C3.02,3.8 3.9,2.95 3.9,1.9Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(18.44246445497629 3.396881516587677)  rotate(0 1.948436018957344 1.8997251184834114)",
    opacity: 1,
    d: "M3.9,1.9C3.9,0.85 3.02,0 1.95,0C0.87,0 0,0.85 0,1.9C0,2.95 0.87,3.8 1.95,3.8C3.02,3.8 3.9,2.95 3.9,1.9Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(32.58426540284358 40.97107109004739)  rotate(0 1.2534597156398075 0.918255924170616)",
    opacity: 1,
    d: "M2.51,0.92L1.25,0L0,0.92L1.25,1.84L2.51,0.92Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#B2BED9"
    },
    transform: "translate(7.25197229310973 38.04551658767772)  rotate(0 7.290995260663505 1.794924170616113)",
    opacity: 1,
    d: "M0.8,3.59L13.78,3.59C14.22,3.59 14.58,3.23 14.58,2.79L14.58,0.8C14.58,0.36 14.22,0 13.78,0L0.8,0C0.36,0 0,0.36 0,0.8L0,2.79C0,3.23 0.36,3.59 0.8,3.59Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#B2BED9"
    },
    transform: "translate(7.25197229310973 44.95683412322274)  rotate(0 7.290995260663505 1.7405829383886244)",
    opacity: 1,
    d: "M0.79,3.48L13.79,3.48C14.23,3.48 14.58,3.13 14.58,2.69L14.58,0.79C14.58,0.35 14.23,0 13.79,0L0.79,0C0.35,0 0,0.35 0,0.79L0,2.69C0,3.13 0.35,3.48 0.79,3.48Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#B2BED9"
    },
    transform: "translate(7.25197229310973 51.72730805687202)  rotate(0 7.290995260663505 1.7405829383886244)",
    opacity: 1,
    d: "M0.79,3.48L13.79,3.48C14.23,3.48 14.58,3.13 14.58,2.69L14.58,0.79C14.58,0.35 14.23,0 13.79,0L0.79,0C0.35,0 0,0.35 0,0.79L0,2.69C0,3.13 0.35,3.48 0.79,3.48Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(7.26334670069267 17.98805687203791)  rotate(0 7.27962085308056 7.09763033175355)",
    opacity: 1,
    d: "M14.56,7.1C14.56,3.18 11.3,0 7.28,0C3.26,0 0,3.18 0,7.1C0,11.02 3.26,14.2 7.28,14.2C11.3,14.2 14.56,11.02 14.56,7.1Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    fillRule: "evenodd",
    style: {
      fill: "#393D65"
    },
    transform: "translate(9.101450966095506 26.5135014793016)  rotate(0 5.44037914691943 2.8349089458697927)",
    opacity: 1,
    d: "M10.88,3.2C9.82,1.23 7.72,0 5.44,0C3.16,0 1.06,1.23 0,3.2C1.35,4.77 3.34,5.67 5.44,5.67C7.54,5.67 9.53,4.77 10.88,3.2Z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#393D65"
    },
    transform: "translate(11.84382063434195 21.45702369668246)  rotate(0 2.737819905213269 2.6693744075829375)",
    opacity: 1,
    d: "M5.48,2.67C5.48,1.2 4.25,0 2.74,0C1.23,0 0,1.2 0,2.67C0,4.14 1.23,5.34 2.74,5.34C4.25,5.34 5.48,4.14 5.48,2.67Z "
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(72.09349673294264 0)  rotate(0 30 30)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 30 29.99999999999998)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 30 29.99999999999998)"
  }, _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-7)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    style: {
      fill: "#764ABC"
    },
    transform: "translate(0.000006637488692027203 -0.00000662292724349299)  rotate(0 29.735949330843287 29.67071402456484)",
    opacity: 1,
    d: "M29.74,59.34C46.16,59.34 59.47,46.05 59.47,29.67C59.47,13.29 46.16,0 29.74,0C13.32,0 0,13.29 0,29.67C0,46.05 13.32,59.34 29.74,59.34Z "
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(14.95057452467397 11.538611009553)  rotate(0 15 16.5)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(5.286390992149915 0)  rotate(0 9.5 6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(0.0049919138897631 0.00759572844590181)  rotate(0 9.494011689679235 6.32154252974732)",
    opacity: 1,
    d: "M0,9.48L0,12.64L3.16,12.64L3.16,9.48C3.16,5.98 5.99,3.15 9.49,3.15C12.99,3.15 15.82,5.98 15.82,9.48L15.82,12.64L18.99,12.64L18.99,9.48C18.99,4.24 14.74,0 9.49,0C4.25,0 0,4.24 0,9.48Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 12.11554156003066)  rotate(0 15 10)"
  }, _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(0.00002471112455907479 0.000004924514340340927)  rotate(0 14.82667473579546 9.84902868315416)",
    opacity: 1,
    d: "M29.65,18.52L29.65,1.18C29.65,0.53 29.12,0 28.47,0L1.19,0C0.53,0 0,0.53 0,1.18L0,18.52C0,19.17 0.53,19.7 1.19,19.7L28.47,19.7C29.12,19.7 29.65,19.17 29.65,18.52Z "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fillRule: "evenodd",
    style: {
      fill: "#764ABC"
    },
    transform: "translate(12.63777846560838 17.5551724645342)  rotate(0 2.2301961998132436 4.450607103684732)",
    opacity: 1,
    d: "M1.08496 4.76742L1.08496 1.11C1.08496 0.5 1.59496 0 2.23496 0C2.86496 0 3.37496 0.5 3.37496 1.11L3.37496 4.76738C4.02457 5.15748 4.46 5.86897 4.46 6.68061C4.46 7.90061 3.46 8.90061 2.23 8.90061C1 8.90061 0 7.90061 0 6.68061C0 5.869 0.435391 5.15754 1.08496 4.76742Z "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPermission);
export default __webpack_public_path__ + "static/media/no_permission.ad402389.svg";
export { ForwardRef as ReactComponent };